import {
	LinkableEntityType,
	getLinkableEntityTypeLabel,
} from '../enums/linkable-entity-type.enum';

/**
 * Issue-notification "category" for issues that have no linked entity.
 * Stored in issue_notification_role_config.category alongside the
 * LinkableEntityType values.
 */
export const ISSUE_NOTIFICATION_GENERAL_CATEGORY = 'general';

export interface IssueNotificationCategoryOptionModel {
	value: string;
	label: string;
}

/**
 * Every issue-notification category surfaced in the Settings admin: each
 * linkable-entity type (Client, Vendor, Vehicle, ...) plus the General
 * catch-all. Driven off LinkableEntityType so it stays complete automatically
 * as new linkable types are added, then sorted alphabetically by label for
 * display. Labels are English; wrap with t() in the UI.
 */
export const ISSUE_NOTIFICATION_CATEGORIES: ReadonlyArray<IssueNotificationCategoryOptionModel> =
	[
		...Object.values(LinkableEntityType).map((type) => ({
			value: type,
			label: getLinkableEntityTypeLabel(type),
		})),
		{ value: ISSUE_NOTIFICATION_GENERAL_CATEGORY, label: 'General' },
	].sort((a, b) => a.label.localeCompare(b.label));
